import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (d) => new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

export function SpaOrdersTab() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/spa-units/orders").then((r) => setData(r.data.items)).catch(() => setData([])); }, []);
  if (!data) return <div className="py-10 text-center text-slate-400"><Loader2 className="w-5 h-5 animate-spin inline" /></div>;
  return (
    <div className="space-y-3" data-testid="spa-orders">
      <p className="text-sm text-slate-500">Drafts built from the spreadsheet's expected arrival dates. Nothing has been sent to any supplier, and no order references or costs have been added.</p>
      {data.map((po) => (
        <section key={po.po_id} className="bg-white border border-slate-200 rounded-2xl p-4" data-testid={`spa-po-${po.po_id}`}>
          <div className="flex flex-wrap items-center gap-2 mb-2">
            <h3 className="font-bold text-slate-900">{po.supplier}</h3>
            <span className="text-sm text-slate-700">Expected {fmt(po.eta)}</span>
            {po.provisional && <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-bold text-amber-800">TBC - provisional</span>}
            {po.overdue && <span className="rounded-full bg-rose-100 px-2 py-0.5 text-[11px] font-bold text-rose-700">Date passed - awaiting confirmation</span>}
            <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-bold uppercase text-slate-600">Draft · not sent</span>
            <span className="sm:ml-auto text-sm font-semibold text-slate-700">{po.received}/{po.qty} received</span>
          </div>
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead className="text-left text-[11px] uppercase text-slate-500"><tr><th className="py-1 pr-3">Product</th><th className="py-1 pr-3 text-right">Qty</th><th className="py-1 pr-3 text-right">Reserved</th><th className="py-1 pr-3 text-right">Received</th><th className="py-1">Serials</th></tr></thead>
            <tbody>{po.lines.map((l) => (
              <tr key={l.product_legacy_id} className="border-t border-slate-100"><td className="py-1.5 pr-3 font-medium">{l.title}</td>
                <td className="py-1.5 pr-3 text-right tabular-nums font-semibold">{l.qty}</td><td className="py-1.5 pr-3 text-right tabular-nums">{l.reserved}</td>
                <td className="py-1.5 pr-3 text-right tabular-nums">{l.received}</td><td className="py-1.5 font-mono text-xs text-slate-500">{l.serials.join(", ") || "-"}</td></tr>))}</tbody>
          </table></div>
        </section>))}
      {!data.length && <p className="text-slate-400">No draft orders.</p>}
    </div>
  );
}
